import { NoddiDialog } from 'noddi-ui-web';
import { useAuthContext } from 'noddi-web';
import { useEffect, useState } from 'react';
import { useCurrentBrand, useSetBrand } from '../../stores/BrandStore/brandStore';
import { BrandThemePicker } from './BrandThemePicker';

export function CustomerCommandPalette() {
  const { userData } = useAuthContext();

  return userData?.user.isSuperuser && <SuperuserCommandPalette />;
}

function SuperuserCommandPalette() {
  const [open, setOpen] = useState(false);
  const { currentBrand } = useCurrentBrand();
  const setBrand = useSetBrand();

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key.toLowerCase() === 'k' && (event.metaKey || event.ctrlKey) && !event.altKey && !event.repeat) {
        event.preventDefault();
        setOpen((wasOpen) => !wasOpen);
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, []);

  return (
    <NoddiDialog
      open={open}
      onClose={() => setOpen(false)}
      title='Command palette'
      description='Search and select a brand theme'
      maxWidth='sm'
    >
      <BrandThemePicker currentBrand={currentBrand} onSelect={setBrand} onDone={() => setOpen(false)} />
    </NoddiDialog>
  );
}
